import React from 'react'
import { DocumentPdf } from './components/DocumentPdf'

const PdfGenerator = () => (
    <>
        <DocumentPdf />
    </>
)

export { PdfGenerator }
